import { socket, refreshSocketAuth } from "./socket";

let activeRoomId = null;
let activeChatParticipantId = null;
let isOnChatPage = false;

const emitJoin = () => {
  if (!socket.connected) return;
  socket.emit("join-support-admins");
  if (activeRoomId) socket.emit("join-chat-room", activeRoomId);
};

export const joinChatRoom = (roomId) => {
  if (!roomId) return;
  activeRoomId = String(roomId);
  refreshSocketAuth();
  if (socket.connected) {
    emitJoin();
  } else {
    socket.once("connect", emitJoin);
  }
};

export const leaveChatRoom = (roomId) => {
  if (!roomId) return;
  socket.emit("leave-chat-room", String(roomId));
  if (activeRoomId === String(roomId)) {
    activeRoomId = null;
  }
};

export const setChatPageContext = (participantId) => {
  isOnChatPage = true;
  activeChatParticipantId = participantId ? String(participantId) : null;
};

export const clearChatPageContext = () => {
  isOnChatPage = false;
  activeChatParticipantId = null;
};

export const getChatPageContext = () => ({
  isOnChatPage,
  activeChatParticipantId,
});

export const isViewingParticipant = (participantId) =>
  isOnChatPage &&
  !!participantId &&
  activeChatParticipantId === String(participantId);

socket.on("connect", emitJoin);

export const getSenderId = (msg) =>
  msg?.sender?._id?.toString() || msg?.sender?.toString() || "";

/** Customer/driver the support message belongs to. */
export const getMessageParticipantId = (msg) => msg?.userId?.toString() || "";

export const subscribeNewMessages = (handler) => {
  socket.on("support-message", handler);
  return () => socket.off("support-message", handler);
};

/** Queue changes: new request, accepted, declined, resolved, cancelled. */
export const subscribeChatStatus = (handler) => {
  socket.on("support-status", handler);
  return () => socket.off("support-status", handler);
};
